import { useRouter } from 'next/router';
import { useState } from 'react';
import { tabsValues } from '../../../config/pageConfig';
import Banner from '../components/Banner';
import GoHome from '../components/GoHome';
import Experience from '../components/Experience';
import Faq from '../components/Faq';
import Gift from '../components/Gift';
import Event from '../components/Event';
import Banner1 from '../components/Banner1';
import YoutubeVideo from '../components/YoutubeVideo';

export default function StatusItem() {
    const { query } = useRouter();
    const searchTab = query?.tab;
    let defaultTab = 'Product';
    if (typeof searchTab === 'string' && tabsValues.includes(searchTab)) {
        defaultTab = searchTab;
    }
    const [activeTab, setActiveTab] = useState(defaultTab);
    const tabCallback = (tabValue: string) => {
        setActiveTab(tabValue);
    };
    return (
        <>
            <Banner />
            <GoHome />
            <div className="lp-layout">
                <div className="line "></div>
            </div>
            <Experience />
            <div className="lp-layout">
                <div className="line "></div>
            </div>
            <Gift />
            <div className="lp-layout">
                <div className="line "></div>
            </div>

            <Faq />
            <Banner1 />
            <YoutubeVideo />

            <Event />
            {/* <ProductNav activeTab={defaultTab} tabCallback={tabCallback} /> */}
        </>
    );
}
